







import { Component, Emit, Mixins, Prop, Watch } from "vue-property-decorator";
import { DomainRegistry } from "../../domain";
import { Patient } from "../../domain/patient";
import { DisableableMixin } from "../system";
import { DuplicatedPatientSelectorDialog } from "./dialogs";

@Component({
  components: {
    DuplicatedPatientSelectorDialog,
  },
})
export default class DuplicatedPatientIndicator extends Mixins(DisableableMixin) {
  data() {
    return {
      isLoading: false,
      hasDuplicatedId: false,
    };
  }
  isLoading: boolean;
  hasDuplicatedId: boolean;

  $refs!: {
    selectorDialog: DuplicatedPatientSelectorDialog,
  };

  get isVisible(): boolean {
    return this.$configuration.behavior.patient.otherId.isEnable;
  }

  @Prop()
  patient: Patient;

  @Prop({ default: "他IDあり" })
  label: string;

  @Watch("patient")
  onPatientUpdated(newValue: Patient, oldValue: Patient) {
    if (!this.isVisible) {
      return;
    }
    if (!newValue) {
      this.isLoading = false;
      this.hasDuplicatedId = false;
      return;
    }
    this.isLoading = true;
    const repo = DomainRegistry.patient.getPatientRepository();
    repo.hasDuplicatedPatientId(newValue.id)
    .then(hasDuplicatedId => {
      if (this.patient && this.patient.id === newValue.id) {
        this.hasDuplicatedId = hasDuplicatedId;
      }
    })
    .catch(e => {
      this.$error("重複ID取得エラー", "患者重複ID取得に失敗しました。", e);
      this.hasDuplicatedId = false;
    })
    .finally(() => {
      this.isLoading = false;
    });
  }

  openSelectDialog(): void {
    this.$refs.selectorDialog.selectOption(this.patient)
    .then(p => {
      if (!!p) {
        this.patientSelected(p);
      }
    });
  }

  @Emit()
  patientSelected(patient: Patient): void {}
}
